import { NavigationFlow } from "../../common/flow";
import { HotelSteps } from "./HotelNavigationFlowProvider";

const useGoToNextStep = (currentStep: HotelSteps) => {
  return NavigationFlow.useGoToNextStep<HotelSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<HotelSteps>();
};

export const HotelNavigationFlow = {
  useGoToNextStep,
  useGoToStep,
};
